export default "__VITE_ASSET__Bg_T$eBS__"